import { connect } from 'react-redux';
import { components } from '@peachjar/components';

import SetupParentContainer from './containers/SetupParentContainer';

import {
  setParentUploadingFile,
  setParentInstructionsCLicked,
  setParentCsvDownloaded,
  toggleParentContinue,
} from './setup-parent.duck';

const {
  Notifications: { notifyError },
} = components;

const mapStateToProps = state => ({
  isButtonDisabled: state.setupParent.isButtonDisabled,
  isUploadContinueDisabled: state.setupParent.isUploadContinueDisabled,
  isUploading: state.setupParent.isUploading,
  uploadingErrors: state.setupParent.uploadingErrors,
  uploadingPercentage: state.setupParent.uploadingPercentage,
  isUploadComplete: state.setupParent.isUploadComplete,
  uploadingFilename: state.setupParent.uploadingFilename,
  parentUploadingValidatedList: state.setupParent.parentUploadingValidatedList,
  parentUploadingInstructionsClicked:
    state.setupParent.parentUploadingInstructionsClicked,
  parentUploadingTemplateCLicked:
    state.setupParent.parentUploadingTemplateCLicked,
  parentUploadTaskId: state.setupParent.parentUploadTaskId,
  isParentIntroContinueDisabled: state.setupParent.isContinueDisabled,
  parentTabView: state.setupParent.parentTabView,
});

const mapDispatchToProps = dispatch => ({
  setParentUploadingFile: fileList => {
    if (fileList.target.files.length > 0) {
      dispatch(setParentUploadingFile(fileList));
      fileList.target.value = '';
    }
  },
  handleParentInstructionsClick: () => {
    dispatch(setParentInstructionsCLicked(true));
  },
  handleParentCsvClick: () => {
    dispatch(setParentCsvDownloaded(true));
  },
  handleContinueDisable: () => {
    dispatch(toggleParentContinue(false));
  },
  onNotifyError: error => {
    dispatch(notifyError(error.message));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetupParentContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/index.js